<div class="form-group" [formGroup]="formGroup">
  {{formField.label}}
  <input #input [formControlName]="formField.key" [attr.maxlength]="formField.maxlength"
    [attr.minlength]="formField.minlength" [attr.max]="formField.max" [attr.min]="formField.min"
    *ngIf="!formField.readonly" [attr.id]="formField.id" [type]="formField.type" [placeholder]="formField.label"
    [ngClass]="{ 'is-invalid': control.errors }" class="form-control" (blur)="onBlur(formField.key)">

  <input #input [formControlName]="formField.key" [attr.maxlength]="formField.maxlength"
    [attr.minlength]="formField.minlength" [attr.max]="formField.max" [attr.min]="formField.min"
    [attr.id]="formField.id" [type]="formField.type" [placeholder]="formField.label" readonly
    [ngClass]="{ 'is-invalid': control.errors }" class="form-control" *ngIf="formField.readonly">

  <div *ngIf="control.errors" class="invalid-feedback d-flex">
    <div *ngIf="control.errors.required" class="invalid-feedback">This is
      required</div>
    <div *ngIf="!control.errors.required" class="invalid-feedback">Invalid {{formField.label}}</div>
    <div align="end" *ngIf="formField.maxlength">
      {{input?.value?.length || 0}}/{{formField.maxlength}}</div>
  </div>
</div>